import { createRequestActions } from "common/helpers/action";

export const sendProfileSettings = createRequestActions("ACCOUNT.SETTING.SEND_PROFILES");
export const sendPasswordSettings = createRequestActions("ACCOUNT.SETTING.SEND_PASSWORD");
